import { gql } from "@apollo/client";

export const FETCH_CUSTOMERS_FOR_FCST = gql`
  query FETCH_CUSTOMERS_FOR_FCST {
    customers(connectedToOdoo: true) {
      id
      name
      system
    }
  }
`;

export const FETCH_FORECAST_CATEGORIES = gql`
  query FETCH_FORECAST_CATEGORIES($mode: String) {
    forecastCategories(mode: $mode) {
      id
      mode
      name: displayName
      description
      connectionType
      customer {
        id
        name
      }
      stockCategory {
        id
        name
      }
      products {
        id
        number
        name
      }

      lastSubmission {
        id
        submittedAt
        user {
          id
          email
        }
      }
    }
  }
`;

export const FETCH_FORECAST_CATEGORY_SUBMISSIONS = gql`
  query FETCH_FORECAST_CATEGORY_SUBMISSIONS($forecastCategoryId: ID!) {
    forecastCategory(id: $forecastCategoryId) {
      id
      name
    }
    submissions: salesForecastSubmissions(
      forecastCategoryId: $forecastCategoryId
    ) {
      id
      data
      submittedAt
      user {
        id
        email
      }
    }
  }
`;

export const FETCH_FORECAST_CATEGORY = gql`
  query FETCH_FORECAST_CATEGORY($id: ID!) {
    forecastCategory(id: $id) {
      id
      mode
      name
      description
      connectionType
      customer {
        id
        name
      }
      stockCategory {
        id
        name
      }
      products {
        id
        number
        name
        version
      }
    }
  }
`;

export const FETCH_FORECAST_CATEGORY_AND_SALES_INFO = gql`
  query FETCH_FORECAST_CATEGORY_AND_SALES_INFO($id: ID!) {
    forecastCategory(id: $id) {
      id
      mode
      name: displayName
      description
      connectionType
      customer {
        id
        name
      }
      stockCategory {
        id
        name
      }
      incFcstSheetName
      products {
        id
        odooId
        number
        name
        version
        countryCodeOfOrigin
        itemsPerSet
        cbm: outerCartonCbm
      }
      stockHistory
      lastSubmission {
        id
        data
        updatedAt
        submittedAt
      }
    }
  }
`;

export const FETCH_FORECAST_CATEGORY_STOCK_HISTORY = gql`
  query FETCH_FORECAST_CATEGORY_STOCK_HISTORY($id: ID!) {
    forecastCategory(id: $id) {
      id
      stockHistory(onlyForecastCategoryProducts: false)
    }
  }
`;

export const SAVE_FORECAST_CATEGORY = gql`
  mutation SAVE_FORECAST_CATEGORY(
    $id: ID
    $mode: String
    $name: String
    $description: String
    $connectionType: String
    $customerId: ID
    $stockCategoryId: ID
    $productIds: [ID]
  ) {
    saveForecastCategory(
      id: $id
      mode: $mode
      name: $name
      description: $description
      connectionType: $connectionType
      customerId: $customerId
      stockCategoryId: $stockCategoryId
      productIds: $productIds
    ) {
      forecastCategory {
        id
        mode
        name
        displayName
        description
        connectionType
        customer {
          id
          name
        }
        stockCategory {
          id
          name
        }
        stockHistory
        products {
          id
          number
          name
          version
        }
      }
    }
  }
`;

export const DELETE_FORECAST_CATEGORY = gql`
  mutation DELETE_FORECAST_CATEGORY($id: ID!) {
    deleteForecastCategory(id: $id) {
      id
    }
  }
`;

export const FORECAST_CATEGORY_SAVE_SUBMISSION = gql`
  mutation FORECAST_CATEGORY_SAVE_SUBMISSION(
    $forecastCategoryId: ID!
    $data: String
    $submittedAt: DateTime
  ) {
    forecastCategorySaveSubmission(
      forecastCategoryId: $forecastCategoryId
      data: $data
      submittedAt: $submittedAt
    ) {
      submission {
        id
        forecastCategory {
          id
        }
        data
        updatedAt
        submittedAt
      }
    }
  }
`;

export const FETCH_SALES_FORECAST_SUBMISSION = gql`
  query FETCH_SALES_FORECAST_SUBMISSION($submissionId: ID!) {
    salesForecastSubmission(id: $submissionId) {
      id
      data
      submittedAt
      forecastCategory {
        id
        name
      }
      user {
        id
        email
      }
      products {
        id
        name
        number
        odooId
        version
        countryCodeOfOrigin
        itemsPerSet
      }
    }
  }
`;
